import React from "react";
import { Tab as SemanticTab } from "semantic-ui-react";

export function Pane({ children, className = "" }) {
  return <SemanticTab.Pane className={className}>{children}</SemanticTab.Pane>;
}
